import { trpc } from '@/lib/trpc';
import { toast } from 'sonner';
import { FaRegTrashCan } from 'react-icons/fa6';
import { ConfirmationModal } from '@/components/helpers/ConfirmationModal';

interface DeleteCampusResourceModalProps {
  isOpen: boolean;
  onClose: () => void;
  resourceId: string;
  resourceTitle: string;
}

export function DeleteCampusResourceModal({
  isOpen,
  onClose,
  resourceId,
  resourceTitle,
}: DeleteCampusResourceModalProps) {
  const utils = trpc.useUtils();

  const deleteMutation = trpc.admin.campusResource.deleteCampusResource.useMutation({
    onSuccess: () => {
      utils.admin.campusResource.getCampusResources.invalidate();
      onClose();
      toast.success('Campus resource deleted successfully!');
    },
    onError: (err) => {
      toast.error(`Failed to delete campus resource: ${err.message}`);
    },
  });

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={() => deleteMutation.mutate({ id: resourceId })}
      title="Delete Campus Resource?"
      description="This resource will be permanently deleted and cannot be restored."
      confirmText="Delete"
      cancelText="Cancel"
      icon={
        <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center">
          <FaRegTrashCan className="w-9 h-9 text-red-500" />
        </div>
      }
      isLoading={deleteMutation.isPending}
      highlightBox={{ text: resourceTitle }}
    />
  );
}